/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { domainsDeleteDomain } from "../funcs/domainsDeleteDomain.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteDomainRequest,
  DeleteDomainSecurity,
} from "../models/operations/deletedomain.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteDomainMutationVariables = {
  request?: DeleteDomainRequest | undefined;
  security?: DeleteDomainSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteDomainMutationData = void;

export type DeleteDomainMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteDomain domains
 *
 * @remarks
 * Delete a custom domain
 */
export function useDeleteDomainMutation(
  options?: MutationHookOptions<
    DeleteDomainMutationData,
    DeleteDomainMutationError,
    DeleteDomainMutationVariables
  >,
): UseMutationResult<
  DeleteDomainMutationData,
  DeleteDomainMutationError,
  DeleteDomainMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteDomainMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteDomain(): MutationKey {
  return ["@gram/client", "domains", "deleteDomain"];
}

export function buildDeleteDomainMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteDomainMutationVariables,
  ) => Promise<DeleteDomainMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteDomain(),
    mutationFn: function deleteDomainMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteDomainMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(domainsDeleteDomain(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
